import React, { useState } from "react";
import { useMyProfile } from "../../../hooks/useMyProfile";
import {
  CameraIcon,
  DocumentTextIcon,
  UserCircleIcon,
  TrashIcon,
  KeyIcon, 
  ShieldCheckIcon, 
} from "@heroicons/react/24/outline";
import LoadingSpinner from "../../../components/UI/LoadingSpinner";
import ErrorMessage from "../../../components/UI/ErrorMessage";
import EmptyState from "../../../components/UI/EmptyState";
import ChangePasswordForm from "./ChangePasswordForm"; // +



const MyProfile = () => {
  const {
    profile,
    loading,
    error,
    changePassword, // 🔥 NUEVO MÉTODO DEL HOOK
    uploadPhoto,
    uploadSignature,
    deletePhoto,
    deleteSignature,
  } = useMyProfile();

  const [photoUploading, setPhotoUploading] = useState(false);
  const [signatureUploading, setSignatureUploading] = useState(false);

  //NUEVOS ESTADOS PARA EL MODAL DE CONTRASENA
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordChanging, setPasswordChanging] = useState(false);
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [passwordError, setPasswordError] = useState(null);

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    console.log("📸 Iniciando upload de foto...", file);

    setPhotoUploading(true);
    try {
      console.log("🔄 Llamando a uploadPhoto...");
      await uploadPhoto(file);
      console.log("✅ uploadPhoto completado exitosamente");
    } catch (err) {
      console.error("❌ Error en handlePhotoUpload:", err);
      alert(`Error al subir la foto: ${err.message}`);
    } finally {
      setPhotoUploading(false);
      e.target.value = "";
    }
  };
  //dos funciones ++
  const handleSignatureUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      alert('La firma debe ser PNG, JPG o JPEG');
      return;
    }

    // CAMBIO: Aumentar limite a 5MB
    if (file.size > 5 * 1024 * 1024) {
      alert('La firma debe ser menor a 5MB');
      return;
    }

    // Crear un objeto Image para validar dimensiones
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      
      const minWidth = 100;  //AJUSTADO (antes 200)
      const minHeight = 40;  // AJUSTADO (antes 80)
      
      if (img.width < minWidth || img.height < minHeight) {
        alert(`La imagen debe tener al menos ${minWidth}x${minHeight} px. Tu imagen tiene ${img.width}x${img.height}.`);
        return;
      }
      
      // Si pasa la validacion, proceder con la subida
      uploadSignatureFile(file);
    };
    
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      uploadSignatureFile(file);
    };
    
    img.src = objectUrl;
  };

  // Funcion separada para la subida real
  const uploadSignatureFile = async (file) => {
    setSignatureUploading(true);
    try {
      await uploadSignature(file);
      console.log('Firma subida exitosamente');
    } catch (err) {
      console.error('Error uploading signature:', err);
      alert(`Error al subir la firma: ${err.message}`);
    } finally {
      setSignatureUploading(false);
      e.target.value = '';
    }
  };
  // hasta aca ++
  const handleDeletePhoto = async () => {
    if (
      window.confirm("¿Estás seguro de que quieres eliminar tu foto de perfil?")
    ) {
      try {
        await deletePhoto();
      } catch (err) {
        console.error("Error deleting photo:", err);
      }
    }
  };

  const handleDeleteSignature = async () => {
    if (
      window.confirm("¿Estás seguro de que quieres eliminar tu firma digital?")
    ) {
      try {
        await deleteSignature();
      } catch (err) {
        console.error("Error deleting signature:", err);
      }
    }
  };

  //NUEVA FUNCION MANEJADORA
  const handlePasswordChange = async (passwordData) => {
    setPasswordChanging(true);
    setPasswordError(null);
    setPasswordSuccess(false);

    try {
      await changePassword(passwordData);
      setPasswordSuccess(true);

      // Cerrar modal despues de 2 segundos si es exitoso
      setTimeout(() => {
        setShowPasswordModal(false);
        setPasswordSuccess(false);
      }, 2000);
    } catch (err) {
      setPasswordError(err.message);
    } finally {
      setPasswordChanging(false);
    }
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage error={error} />;
  if (!profile)
    return (
      <EmptyState icon={DocumentTextIcon} title="No se pudo cargar el perfil" />
    );

  const getRoleDisplay = (role) => {
    const roles = {
      professional: "Profesional",
      supervisor: "Supervisor",
      manager: "Gerente",
    };
    return roles[role] || role;
  };

  return (
    <div className="max-w-4xl mx-auto">
      {/* NUEVA SECCION: Boton de cambio de contrasena en la parte superior */}
      <div className="mb-4 flex justify-end">
        <button
          onClick={() => setShowPasswordModal(true)}
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors shadow-sm"
        >
          <KeyIcon className="h-5 w-5 mr-2" />
          Cambiar Password
        </button>
      </div>

      {/* NUEVO MODAL: Cambio de contrasena */}
      {showPasswordModal && (
        <ChangePasswordForm
          onSubmit={handlePasswordChange}
          onCancel={() => setShowPasswordModal(false)}
          loading={passwordChanging}
        />
      )}

      {/* NUEVA NOTIFICACION DE EXITO */}
      {passwordSuccess && (
        <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center">
            <ShieldCheckIcon className="h-5 w-5 text-green-600 mr-2" />
            <p className="text-green-700 text-sm">
              Password cambiado.
            </p>
          </div>
        </div>
      )}

      {/* NUEVA NOTIFICACION DE ERROR */}
      {passwordError && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <div className="flex items-center">
            <svg
              className="w-5 h-5 text-red-600 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
              ></path>
            </svg>
            <p className="text-red-700 text-sm">{passwordError}</p>
          </div>
        </div>
      )}
      {/* hasta aca */}

      <div className="card">
        <div className="px-4 py-5 sm:px-6 bg-gray-50">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Mi Perfil
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            Información personal y configuración de tu cuenta.
          </p>
        </div>

        <div className="border-t border-gray-200">
          <dl>
            {/* Información Básica */}
            {[
              { label: "Usuario", value: profile.username },
              { label: "Nombre completo", value: profile.full_name },
              { label: "Email", value: profile.email },
              {
                label: "Teléfono",
                value: profile.phone_number || "No proporcionado",
              },
              { label: "Rol", value: getRoleDisplay(profile.role) },
            ].map((item, index) => (
              <div
                key={item.label}
                className={`${index % 2 === 0 ? "bg-gray-50" : "bg-white"} px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6`}
              >
                <dt className="text-sm font-medium text-gray-500">
                  {item.label}
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {item.value}
                </dd>
              </div>
            ))}

            {/* Foto de Perfil */}
            <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Foto de perfil
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0">
                    {profile.photo_url ? (
                      <img
                        src={profile.photo_url}
                        alt="Foto de perfil"
                        className="h-24 w-24 rounded-full object-cover border-2 border-gray-200"
                      />
                    ) : (
                      <div className="h-24 w-24 rounded-full bg-gray-200 flex items-center justify-center border-2 border-gray-300">
                        <UserCircleIcon className="h-12 w-12 text-gray-400" />
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col space-y-3">
                    <div>
                      <label className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500">
                        <span>
                          {photoUploading ? "Subiendo..." : "Cambiar foto"}
                        </span>
                        <input
                          type="file"
                          className="sr-only"
                          accept="image/*"
                          onChange={handlePhotoUpload}
                          disabled={photoUploading}
                        />
                      </label>
                    </div>
                    {profile.photo_url && (
                      <button
                        onClick={handleDeletePhoto}
                        className="flex items-center space-x-1 text-red-600 hover:text-red-500 text-sm"
                      >
                        <TrashIcon className="h-4 w-4" />
                        <span>Eliminar foto</span>
                      </button>
                    )}
                    <p className="text-xs text-gray-500 max-w-xs">
                      Formatos: JPG, PNG, GIF. Tamaño máximo: 5MB
                    </p>
                  </div>
                </div>
              </dd>
            </div>

            {/* Firma Digital */}
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Firma digital
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0">
                    {profile.signature_url ? (
                      <div className="border-2 border-gray-200 rounded-lg p-2 bg-white">
                        <img
                          src={profile.signature_url}
                          alt="Firma digital"
                          className="h-16 object-contain max-w-xs"
                        />
                        {profile.watermark_aplicado && (
                          <div className="mt-1 flex items-center space-x-1">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="text-xs text-green-600">
                              Watermark aplicado
                            </span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="h-20 w-48 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50">
                        <DocumentTextIcon className="h-8 w-8 text-gray-400" />
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col space-y-3">
                    <div>
                      <label className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500">
                        <span>
                          {signatureUploading
                            ? "Subiendo..."
                            : profile.signature_url
                              ? "Cambiar firma"
                              : "Subir firma"}
                        </span>
                        <input
                          type="file"
                          className="sr-only"
                          accept="image/png,image/jpeg,image/jpg"
                          onChange={handleSignatureUpload}
                          disabled={signatureUploading}
                        />
                      </label>
                    </div>
                    {profile.signature_url && (
                      <button
                        onClick={handleDeleteSignature}
                        className="flex items-center space-x-1 text-red-600 hover:text-red-500 text-sm"
                      >
                        <TrashIcon className="h-4 w-4" />
                        <span>Eliminar firma</span>
                      </button>
                    )}
                    {/* desde aca */}
                    <div className="text-xs text-gray-500 max-w-xs">
                      <p>Formatos: PNG, JPG, JPEG. Tamaño máximo: <span className="font-medium text-blue-600">5MB</span></p>
                      <p>Dimensiones mínimas: <span className="font-medium text-blue-600">100x40 píxeles</span></p>
                      {profile.fecha_watermark && (
                        <p className="text-green-600">
                          Watermark aplicado:{" "}
                          {new Date(profile.fecha_watermark).toLocaleDateString()}
                        </p>
                      )}
                    </div>
                    {/**hasta aca */}
                  </div>
                </div>
              </dd>
            </div>

            {/* Información de Auditoría */}
            {[
              {
                label: "Miembro desde",
                value: new Date(profile.created_at).toLocaleDateString(
                  "es-ES",
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  },
                ),
              },
              {
                label: "Última actualización",
                value: new Date(profile.updated_at).toLocaleDateString(
                  "es-ES",
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  },
                ),
              },
            ].map((item, index) => (
              <div
                key={item.label}
                className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6`}
              >
                <dt className="text-sm font-medium text-gray-500">
                  {item.label}
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
